import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TcButton from '../../TcButton';
import TcPaper from '../../TcPaper';
import { useDeviceDetection } from '../../../hooks/useDeviceDetection';
import TcPopupR65 from '../../TcPopupR65';
import TcScanQrCodeBar from '../../TcScanQrCodeBar';


export default function NoPersonalization() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isPopupOpen, setIsPopupOpen] = useState(true);

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };


    // Device detection
    const { orientation } = useDeviceDetection();
    const isLandscape = orientation === 'landscape';

    
    return (
        <div className={`
            main-content-wrapper bg-image-galaxy 
            !pb-32 
            ${isLandscape ? '!pt-8' : '!pt-[112px]'} 
            unselectable 
            has-transition 
        `}>
            <div className={`
                    flex flex-col w-full 2xs:pb-20 xs:pb-0 sm:pb-0 
                    gap-4 2xs:gap-0 xs:gap-0 sm:gap-4 
                    2xs-landscape:gap-0 xs-landscape:gap-0 
                    2xs-landscape:text-left xs-landscape:text-left 
                    2xs-landscape:px-4 xs-landscape:px-12
            `}>
                <TcPaper classNameStyle="mt-6">
                    <h1 
                        className="main-content-title" 
                        dangerouslySetInnerHTML={{ __html: t('exhibitShared.noPersonalizationTitle') }}
                    />
                </TcPaper>
                
                <TcPaper classNameStyle="general-content mt-4">
                    <p className="text-2xl" dangerouslySetInnerHTML={{ __html: t('exhibitShared.noPersonalizationMessage1') }} />

                    <p dangerouslySetInnerHTML={{ __html: t('exhibitShared.noPersonalizationMessage2') }} />

                    <p dangerouslySetInnerHTML={{ __html: t('exhibitShared.noPersonalizationMessage3') }} />

                    {!isPopupOpen && <div className="button-wrapper mt-6">
                        <TcButton
                            handleClick={() => navigate('/register')}
                            hollow
                        >
                            {t('exhibitShared.registerNow')}
                        </TcButton>
                    </div>}
                </TcPaper>
            </div>


            {isPopupOpen && (
                <div className={`fixed top-0 bottom-0 left-0 right-0 z-[15] ${isPopupOpen ? 'opacity-100' : 'opacity-0'} has-transition`}>
                    <TcPopupR65
                        handleClose={handleClosePopup}
                    >
                        <div className='flex flex-col items-center justify-center mt-2 mb-4 pb-6 border-b border-gray-900 border-dashed'>
                            <p className='leading-tight'>{t('exhibitShared.noPersonalizationMessage4')}</p>
                            <TcButton
                                handleClick={() => navigate('/register')}
                                classNameStyle={`!text-neutral-950 border-neutral-950`}
                                hollow
                            >
                                {t('exhibitShared.registerNow')}
                            </TcButton>
                        </div>
                        
                        <div
                            className={`leading-tight text-lg`}
                            dangerouslySetInnerHTML={{ __html: t('exhibitShared.continueExploring') }}
                        />
                    </TcPopupR65>
                </div>
            )}

            <TcScanQrCodeBar classNameStyle="fixed bottom-0 left-0 right-0 z-[20]" />
        </div>
    );
} 